class QhRecessoResumo {
  constructor(dados) {
    this.funcao = dados ? dados.funcao : null;
    this.qhDom = dados && dados.qhDom != null ? dados.qhDom : 0;
    this.qhSeg = dados && dados.qhSeg != null ? dados.qhSeg : 0;
    this.qhTer = dados && dados.qhTer != null ? dados.qhTer : 0;
    this.qhQua = dados && dados.qhQua != null ? dados.qhQua : 0;
    this.qhQui = dados && dados.qhQui != null ? dados.qhQui : 0;
    this.qhSex = dados && dados.qhSex != null ? dados.qhSex : 0;
    this.qhSab = dados && dados.qhSab != null ? dados.qhSab : 0;
    this.total = dados && dados.total != null ? dados.total : 0;
  }
}
export default QhRecessoResumo;
